import { useEffect, useState } from 'react';
import { API_BASE } from './api-base';
import { SPACE_CARD_SPEC, toggleOverride } from './dev-feature-toggles';

/**
 * Client read of the new Space card — `symphonySpaceCardV2`, conducted server-side (`/api/flags/space-card`).
 *
 * FAILS CLOSED to off (today's site strip) until the gate answers, and on any error. A dev-tools Feature toggles
 * override wins over the conducted value, and is inert without a dev-tools grant.
 */
const GATE_TIMEOUT_MS = 1500;

let cached: Promise<boolean> | null = null;

export function spaceCardEnabled(): Promise<boolean> {
  // Checked on every call, not memoized: the override can be set mid-session from the dev panel.
  const forced = toggleOverride(SPACE_CARD_SPEC);
  if (forced !== undefined) return Promise.resolve(forced === 'true');
  if (cached) return cached;
  cached = (async () => {
    try {
      const res = await fetch(`${API_BASE}/api/flags/space-card`, {
        credentials: 'include',
        signal: AbortSignal.timeout(GATE_TIMEOUT_MS),
      });
      if (!res.ok) {
        cached = null;
        return false;
      }
      return ((await res.json()) as boolean) === true;
    } catch {
      cached = null;
      return false;
    }
  })();
  return cached;
}

/** The arm, for rendering. Starts false: today's strip until the gate answers. */
export function useSpaceCardEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let live = true;
    void spaceCardEnabled().then((on) => {
      if (live) setEnabled(on);
    });
    return () => {
      live = false;
    };
  }, []);
  return enabled;
}
